import { FC } from 'react';
import { useLocation } from 'react-router-dom';

import { useApplicationConfig } from '@bonusly/application';
import { Box } from '@bonusly/design-system';

function toRailsPath(pathname: string): string {
	const shellPrefix = pathname.startsWith('/super_admin/') ? '/super_admin' : '/admin';
	const afterShell = pathname.slice(shellPrefix.length);

	if (afterShell.startsWith('/r/') || afterShell === '/r') {
		return afterShell.slice(2) || '/';
	}

	return pathname;
}

/**
 * Renders a server-rendered Rails page inside an iframe, keeping the
 * Kaleidoscope shell (admin nav, Bizy side panel) mounted around it.
 *
 * Links inside the iframe eject to the top window via <base target="_top">.
 */
export const AdminLegacyPage: FC = () => {
	const recognizeOrigin = useApplicationConfig('recognizeOrigin');
	const location = useLocation();

	const railsPath = toRailsPath(location.pathname);
	const separator = location.search ? `${location.search}&_iframe=1` : '?_iframe=1';
	const iframeSrc = `${recognizeOrigin}${railsPath}${separator}`;

	return (
		<Box w="100%" h="100%">
			<iframe
				key={location.pathname}
				src={iframeSrc}
				title="Admin"
				style={{
					width: '100%',
					height: '100%',
					border: 'none',
					display: 'block',
				}}
			/>
		</Box>
	);
};
